<template>
    <p class="relative m-0 inline text-sm">
        <mark :style="markStyle" class="bg-inherit text-theme-text">{{ text }}</mark>
    </p>
</template>

<script>
import hexToRgba from '../../../js/utils/hexToRgba';

export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        isAnnotation: {
            type: Boolean,
            default: false,
        },
        highlightColor: {
            type: String,
            default: 'transparent',
        },
    },
    computed: {
        markStyle() {
            return {
                backgroundColor: hexToRgba(this.highlightColor, 0.3),
                padding: '2px 0',
                boxDecorationBreak: 'clone',
                WebkitBoxDecorationBreak: 'clone',
            };
        },
    },
};
</script>
